<template>
  <div class="statistics_item">
    <div class="statistics_item_title">
      {{ title }}
    </div>
    <div class="statistics_item_body">
      <div class="statistics_item_body2">
        <img class="icon2_left_top" src="../../../assets/icon2_left_top.png" alt="">
        <img class="icon2_bottom_left" src="../../../assets/icon2_bottom_left.png" alt="">
        <img class="icon2_top_right" src="../../../assets/icon2_top_right.png" alt="">
        <img class="icon2_bottom_right" src="../../../assets/icon2_bottom_right.png" alt="">
        <div class="num">
          <div class="size" :style="'color:'+config.style.fill">{{ config.number[0] }}</div>
        </div>
        <img class="mr10" v-if="type=='up'" src="../../../assets/icon_up.png" alt="">
        <img class="mr10" v-else src="../../../assets/icon_down.png" alt="">
      </div>
      <span class="yuan">{{ dw }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "statistics_item",
  components: {},
  props: {
    title: {
      type: String,
      default() {
        return '今日成交额';
      }
    }, dw: {
      type: String,
      default() {
        return '元';
      }
    },
    config: {
      default() {
        return {
          number: [100],
          textAlign: 'left',
          style: {
            fontSize: 20,
            fill: '#3de7c9',
          }
        }
      }
    },
    type: {
      type: String,
      default() {
        return 'up';
      }
    },
    num: {
      type: Number,
      default() {
        return 383232;
      }
    },

  },
  data() {
    return {
      status: '',
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.num {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: relative;
  height: 100%;
}

.size {
  font-family: 'ds-digitalnormal';
  font-size: 20px;
  margin-left: 10px;
}

@font-face {
  font-family: 'ds-digitalnormal';
  src: url('../../../assets/fonts/ds-digi.woff2') format('woff2'),
  url('../../../assets/fonts/ds-digi.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

.statistics_item_body2 {
  width: 85%;
  position: relative;
  height: .5rem;
  background: rgba(119, 240, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .icon2_bottom_left {
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .icon2_top_right {
    position: absolute;
    right: 0;
    top: 0;
  }

  .icon2_left_top {
    position: absolute;
    left: 0;
    top: 0;
  }

  .icon2_bottom_right {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.statistics_item_body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: relative;
  height: 50%;

  .yuan {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #BBD1EE;
    margin-left: 8px;
  }
}

.statistics_item_title {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ACB3C4;
  margin-bottom: 10px;
}

.mr10 {
  margin-right: 10px;
}
</style>
